import { create } from "zustand";
import { apiClient } from "@yrbp/api-client";

interface UserInfo {
  id: string;
  username: string;
  role: string;
  mahalla_id: string | null;
}

interface AuthState {
  access: string | null;
  refresh: string | null;
  user: UserInfo | null;
  login: (username: string, password: string) => Promise<void>;
  logout: () => void;
  isAuthenticated: () => boolean;
}

const LS_ACCESS = "yrbp-worker-access-token";
const LS_REFRESH = "yrbp-worker-refresh-token";
const LS_USER = "yrbp-worker-user";

export const useAuth = create<AuthState>((set, get) => ({
  access: localStorage.getItem(LS_ACCESS),
  refresh: localStorage.getItem(LS_REFRESH),
  user: (() => {
    try { return JSON.parse(localStorage.getItem(LS_USER) ?? "null"); }
    catch { return null; }
  })(),

  isAuthenticated: () => {
    const access = get().access;
    if (!access) return false;
    try {
      const { exp } = JSON.parse(atob(access.split(".")[1] ?? ""));
      if (exp * 1000 <= Date.now()) {
        localStorage.removeItem(LS_ACCESS);
        localStorage.removeItem(LS_REFRESH);
        localStorage.removeItem(LS_USER);
        set({ access: null, refresh: null, user: null });
        return false;
      }
      return true;
    } catch {
      return false;
    }
  },

  login: async (username, password) => {
    const res = await apiClient.post("/api/v1/auth/login/", { username, password });
    const { access, refresh, user } = res.data;
    localStorage.setItem(LS_ACCESS, access);
    localStorage.setItem(LS_REFRESH, refresh);
    localStorage.setItem(LS_USER, JSON.stringify(user));
    set({ access, refresh, user });
  },

  logout: () => {
    localStorage.removeItem(LS_ACCESS);
    localStorage.removeItem(LS_REFRESH);
    localStorage.removeItem(LS_USER);
    set({ access: null, refresh: null, user: null });
  },
}));
